import React from 'react'
import PropTypes from 'prop-types'

class Popup extends React.Component {

  constructor(props) {
    super(props)

    this.state ={
      hide_component: true,
    }
  }

  static getDerivedStateFromProps(nextProps) {
    return ({hide_component: nextProps.hide_component});
  }

  componentDidMount() {
    if(this.props.callAfterDidMount) {
      this.props.callAfterDidMount()
    }
  }

  setBackground = () => {
    if(this.props.mobileBackground ) {
      return this.props.mobileBackground();
    }
    return null;
  }

  render() {
    if (this.state.hide_component) return null;

    return (
      <div className="overlay">
        <span className="overlay__close" onClick={this.props.handleCloseButton}></span>
        <div className="modal color-neutrals-black" id="mobile-background" style={this.setBackground()}>
          <span className="modal__close" onClick={this.props.handleCloseButton}></span>
          <div className="row" id="responsive-row">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

Popup.propTypes = {
  handleCloseButton: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

export default Popup
